// extracted by mini-css-extract-plugin
export var content = "_7i-3";
export var list = "_7i-4";
export var settingsContent = "_7i-7";
export var settingsPanel = "_7i-8";
export var state = "_7i-6";
export var triggerBadge = "_7i-2";
export var triggerButton = "_7i-1";
export var triggerShell = "_7i-0";
export var unreadDot = "_7i-5";